/**
 * SettlementTableRow Component
 * 협력사 주정산내역 테이블 행 컴포넌트
 */
import React from 'react';
import { PartnerSettlement } from '../types/partnerSettlement.types';
import { formatCurrency } from '@/shared/utils/formatter';
import { shouldShowColumn } from '../../../shared/lib/settlementHelpers';

interface SettlementTableRowProps {
    settlement: PartnerSettlement;
    index: number;
    currentPage: number;
    isSupplierUser: boolean;
}

const SettlementTableRow: React.FC<SettlementTableRowProps> = ({
    settlement,
    index,
    currentPage,
    isSupplierUser
}) => {
    return (
        <tr>
            {/* 1. NO */}
            {shouldShowColumn(1, isSupplierUser) && (
                <td className="text-center">{(currentPage - 1) * 10 + index + 1}</td>
            )}

            {/* 2. 협력사명 */}
            {shouldShowColumn(2, isSupplierUser) && (
                <td>{settlement.supplierName}</td>
            )}

            {/* 3. 사업자번호 */}
            {shouldShowColumn(3, isSupplierUser) && (
                <td className="text-center">{settlement.businessNumber}</td>
            )}

            {/* 4. 사업자명 */}
            {shouldShowColumn(4, isSupplierUser) && (
                <td>{settlement.businessName}</td>
            )}

            {/* 5. 정산시작일 */}
            {shouldShowColumn(5, isSupplierUser) && (
                <td className="text-center">{settlement.settlementStartDate}</td>
            )}

            {/* 6. 정산종료일 */}
            {shouldShowColumn(6, isSupplierUser) && (
                <td className="text-center">{settlement.settlementEndDate}</td>
            )}

            {/* 7. 지급일 */}
            {shouldShowColumn(7, isSupplierUser) && (
                <td className="text-center">{settlement.paymentDate}</td>
            )}

            {/* 8. 처리건수 */}
            {shouldShowColumn(8, isSupplierUser) && (
                <td className="text-center">{formatCurrency(settlement.processCount)}</td>
            )}

            {/* 9. 배달료 */}
            {shouldShowColumn(9, isSupplierUser) && (
                <td style={{ textAlign: 'right' }}>{formatCurrency(settlement.deliveryFee)}</td>
            )}

            {/* 10. 추가정산 */}
            {shouldShowColumn(10, isSupplierUser) && (
                <td style={{ textAlign: 'right' }}>{formatCurrency(settlement.additionalSettlement)}</td>
            )}

            {/* 11. 관리비 */}
            {shouldShowColumn(11, isSupplierUser) && (
                <td style={{ textAlign: 'right' }}>{formatCurrency(settlement.managementFee)}</td>
            )}

            {/* 12. 공급가액 */}
            {shouldShowColumn(12, isSupplierUser) && (
                <td style={{ textAlign: 'right' }}>{formatCurrency(settlement.supplyAmount)}</td>
            )}

            {/* 13. 부가세액 */}
            {shouldShowColumn(13, isSupplierUser) && (
                <td style={{ textAlign: 'right' }}>{formatCurrency(settlement.vat)}</td>
            )}

            {/* 14. 공급대가 */}
            {shouldShowColumn(14, isSupplierUser) && (
                <td style={{ textAlign: 'right' }}>{formatCurrency(settlement.supplyPrice)}</td>
            )}

            {/* 15. 지점 운영 수수료 */}
            {shouldShowColumn(15, isSupplierUser) && (
                <td style={{ textAlign: 'right' }}>{formatCurrency(settlement.branchOperationFee)}</td>
            )}

            {/* 16. 달성 페이백 */}
            {shouldShowColumn(16, isSupplierUser) && (
                <td style={{ textAlign: 'right' }}>{formatCurrency(settlement.achievementPayback)}</td>
            )}

            {/* 17. 프로모션 */}
            {shouldShowColumn(17, isSupplierUser) && (
                <td style={{ textAlign: 'right' }}>{formatCurrency(settlement.promotion)}</td>
            )}

            {/* 18. 지급관리비(vat포함) */}
            {shouldShowColumn(18, isSupplierUser) && (
                <td style={{ textAlign: 'right' }}>{formatCurrency(settlement.paymentManagementFee)}</td>
            )}

            {/* 19. 일차감 */}
            {shouldShowColumn(19, isSupplierUser) && (
                <td style={{ textAlign: 'right' }}>{formatCurrency(settlement.dailyDeduction)}</td>
            )}

            {/* 20. 사업주_고용 */}
            {shouldShowColumn(20, isSupplierUser) && (
                <td style={{ textAlign: 'right' }}>{formatCurrency(settlement.employerEmployment)}</td>
            )}

            {/* 21. 사업주_산재 */}
            {shouldShowColumn(21, isSupplierUser) && (
                <td style={{ textAlign: 'right' }}>{formatCurrency(settlement.employerIndustrial)}</td>
            )}

            {/* 22. 보험료합계 */}
            {shouldShowColumn(22, isSupplierUser) && (
                <td style={{ textAlign: 'right' }}>{formatCurrency(settlement.insuranceTotal)}</td>
            )}

            {/* 23. 실 지급 금액 */}
            {shouldShowColumn(23, isSupplierUser) && (
                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatCurrency(settlement.actualPayment)}</td>
            )}
        </tr>
    );
};

export default SettlementTableRow;
